import {
  SurveyMethodologyDefaultContentTemplateDynamicZone,
  SurveyMethodologyPageQuery,
  SurveyMethodologyPageQueryVariables,
} from '@/graphql/generated/graphql';
import DefaultContentTemplatePage from '../default-content-template';
import { QUERY_SURVEY_METHODOLOGY_PAGE } from '@/graphql/queries/survey-methodology/survey-methodology';
import { useQuery } from '@apollo/client';

export const SurveyMethodology = () => {
  const { data, loading } = useQuery<SurveyMethodologyPageQuery, SurveyMethodologyPageQueryVariables>(
    QUERY_SURVEY_METHODOLOGY_PAGE,
  );

  const page = data?.surveyMethodology?.data?.attributes;

  const template = page?.DefaultContentTemplate as SurveyMethodologyDefaultContentTemplateDynamicZone[];

  if (loading) {
    return null;
  }

  return (
    <>
      <DefaultContentTemplatePage template={template} title={page?.pageTitle || 'Back to the Homepage'} />
    </>
  );
};

export default SurveyMethodology;
